// extracted by css-extract-rspack-plugin
export default {"Input":"Input-emksYf","input":"Input-emksYf","CheckBoxInput":"CheckBoxInput-VDUdU7","checkBoxInput":"CheckBoxInput-VDUdU7"};